export default {
	SET_LOCATION: 'SET_LOCATION'
}
